import DialogActions from '@zenbusiness/zui/DialogActions';
import DialogContent from '@zenbusiness/zui/DialogContent';
import { styled } from '@zenbusiness/zui/styles';

export const DialogActionsStyled = styled(DialogActions)(({ theme }) => ({
  width: '100%',
  bottom: 0,
  right: 0,
  padding: '16px',
  position: 'fixed',
  [theme.breakpoints.up('sm')]: {
    display: 'box',
    padding: '16px 60px',
    maxWidth: '1450px',
    margin: 'auto'
  }
}));

export const DialogContentStyled = styled(DialogContent)(() => ({
  paddingTop: '16px',
  paddingBottom: '65px'
}));
